import React from 'react'

interface SvgSnapGuidesProps {
  snapGuides: { x: number[], y: number[] }
}

const SvgSnapGuides = React.memo(function SvgSnapGuides({ snapGuides }: SvgSnapGuidesProps) {
  return (
    <>
      {snapGuides.x.length > 0 && (
        <g>
          {snapGuides.x.map((x, index) => (
            <line
              key={`snap-v-${index}`}
              x1={x}
              y1={-5000}
              x2={x}
              y2={5000}
              stroke="hsl(var(--primary))"
              strokeWidth="1"
              strokeDasharray="3,3"
              opacity="0.8"
              pointerEvents="none"
            />
          ))}
        </g>
      )}
      {snapGuides.y.length > 0 && (
        <g>
          {snapGuides.y.map((y, index) => (
            <line
              key={`snap-h-${index}`}
              x1={-5000}
              y1={y}
              x2={5000}
              y2={y}
              stroke="hsl(var(--primary))"
              strokeWidth="1"
              strokeDasharray="3,3"
              opacity="0.8"
              pointerEvents="none"
            />
          ))}
        </g>
      )}
    </>
  )
})

export default SvgSnapGuides
